import React, { useEffect } from "react";
import styles from "../ContactUs/contactStyle.module.css";
// import Mail from "../../commomComponents/mail";
import formName from "../../assets/images/form-name.svg";
import formMail from "../../assets/images/form-mail.svg";
import formContact from "../../assets/images/form-contact.svg";
import query from "../../assets/images/select-inquiry-golden.svg";
import originalQuery from "../../assets/images/select-inquiry-gray.svg";
import formNameChange from "../../assets/images/form-name-golden.svg";
import formMailChange from "../../assets/images/form-mail-golden.svg";
import formContactChange from "../../assets/images/form-contact-golden.svg";
import pan from "../../assets/images/pan-number-gray.svg";
import panGolden from "../../assets/images/pan-number-golden.svg";
import client from "../../assets/images/client-id-gray.svg";
import clientGolden from "../../assets/images/client-id-golden.svg";
import msg from "../../assets/images/query-message-gray.svg";
import msgGolden from "../../assets/images/query-message-golden.svg";
import location from "../../assets/images/location-point.svg";
import { useState } from "react";
import getContactDetails from "../../services/request/contact";
import ReactHtmlParser from "react-html-parser";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import { sender } from "../../utils/sendMail";
import ContactusBanner from "../../assets/images/existing-banner.jpg";

import setContactDetails from "../../services/setRequest/setContactDetails";

import {
  InputLabel,
  TextField,
  MenuItem,
  FormControl,
  Select,
  useMediaQuery,
} from "@material-ui/core";
import {
  decrypt,
  encrypt,
  generateSecreteKey,
  createRequestIds,
} from "../../services/encryptionDecryptionService";
import {
  EMAIL_PLACEHOLDER,
  ENTER_VALID_CONTACT_NUMBER,
  ENTER_VALID_EMAIL,
  TOAST_COMMON_ERROR,
  TOAST_COMMON_SUCCESS,
  encryptDecryptKey,
} from "../../constants/Constants";
import Loader from "../../commomComponents/Loader";
import Mail from "../../commomComponents/mail";
import toast from "react-hot-toast";
import { hashWithSHA256, isEmailValid } from "../../utils/commonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SeoHelmet from "../../commomComponents/seoHelmet";

let inquiries = [
  {
    id: 1,
    name: "Query",
  },
  {
    id: 2,
    name: "Request for statement",
  },
  {
    id: 3,
    name: "Feedback",
  },
  {
    id: 4,
    name: "Complaint",
  },
];

const ContactUs = () => {
  const [inquiry, setInquiry] = React.useState("");
  const [changeImage, setChangeImage] = React.useState(false);
  const [fullname, setFullName] = React.useState("");
  const [nameErrorMsg, setNameErrorMsg] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);
  const [changeMail, setChanEemail] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [emailErrorMsg, setEmailErrorMsg] = React.useState(false);
  const [changeContact, setChangeContact] = React.useState(false);
  const [isActive, setIsActive] = useState(false);
  const [countryCode, setCountryCode] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [numberErrorMsg, setNumberErrorMsg] = React.useState(false);
  const [panImg, setPanImg] = React.useState(false);
  const [selectQuery, setSelectQuery] = React.useState(false);
  const [clientImg, setClientImg] = React.useState(false);
  const [msgImg, setMsgImg] = React.useState(false);
  const [panValue, setPanValue] = React.useState("");
  const [panError, setPanError] = React.useState(false);
  const [clientError, setClientError] = React.useState(false);
  const [clientValue, setClientValue] = React.useState("");
  const [msgValue, setMsgValue] = React.useState("");
  const [responseData, setResponseData] = React.useState([]);
  const [banner, setBanner] = React.useState([]);
  const [formbackground, setFormBackground] = React.useState([]);
  const [offices, setOffices] = React.useState([]);
  const [branches, setBranches] = React.useState([]);

  const [requestId, setRequestId] = React.useState(0);
  const [requestIDs, setRequestIds] = React.useState([]);
  const [apiError, setApiError] = React.useState(false);
  const [loader, setLoader] = useState(false);
  const history = useHistory();

  const handleChange = (event) => {
    setInquiry(event.target.value);
  };

  function handleImageChangeFormName() {
    setChangeImage(true);
  }
  function handleChangeImageFormName() {
    setChangeImage(false);
  }
  function handleImageChangeFormMail() {
    setChanEemail(true);
  }
  function handleChangeImageFormMail() {
    setChanEemail(false);
  }
  function handleImageChangeFormContact() {
    setChangeContact(true);
  }
  function handleChangeImageFormContact() {
    setChangeContact(false);
  }
  function handleImageChangepan() {
    setPanImg(true);
  }
  function handleChangeImagepan() {
    setPanImg(false);
  }
  function handleImageChangeQury() {
    setSelectQuery(true);
  }
  function handleChangeImageQuery() {
    setSelectQuery(false);
  }
  function handleImageChangeClientId() {
    setClientImg(true);
  }
  function handleChangeImageClienId() {
    setClientImg(false);
  }
  function handleImageChangeMsg() {
    setMsgImg(true);
  }
  function handleChangeImageMsg() {
    setMsgImg(false);
  }

  function changeRequestId(txnId) {
    var secret = "";
    console.warn(JSON.stringify(requestIDs));
    var latest = requestIDs.filter(function (val) {
      if (val.requestId === txnId) {
        secret = val.secret.substring(
          0,
          val.secret.length - val.requestId.length
        );
        return false;
      }
      return true;
    });
    setRequestIds(latest);
    return secret;
  }

  function handleChangeName(event) {
    let alphabets =
      /^[\u00C0-\u017Fa-zA-Z'’‘’][\u00C0-\u017Fa-zA-Z’‘’' ' ']+[\u00C0-\u017Fa-zA-Z'’‘’]?$/;
    let name = event.target.value;
    setFullName(name);
    if (name.match(alphabets)) {
      setNameErrorMsg(false);
    } else if (name.match(/^[A-Z]*$/)) {
      setNameErrorMsg(false);
    } else {
      setNameErrorMsg(true);
    }
  }
  function handleEmailChange(event) {
    let email = event.target.value;
    setEmail(email);
  }
  function handleTextChange(text) {
    let num = /^-?\d*$/.test(text);
    if (num) {
      setIsActive(true);
      //setCountryCode(true);
      setContactNumber(text);
      setNumberErrorMsg(false);
    } else {
      setNumberErrorMsg(true);
    }
  }

  function handleChangePan(event) {
    let panNo = event.target.value;
    let regexp = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);
    setPanValue(panNo);

    if (regexp.test(panNo)) {
      setPanError(false);
    } else {
      setPanError(true);
    }
  }
  function handleChangeClientId(event) {
    let clientID = event.target.value;
    let regexp = new RegExp(/^[a-zA-Z0-9]*$/);
    if (regexp.test(clientID)) {
      setClientValue(clientID);
      setClientError(false);
    } else {
      setClientError(true);
    }
  }
  function handleChangeMsg(event) {
    setMsgValue(event.target.value);
  }

  async function handleSubmit() {
    //datalayer
    const hashedEmail = await hashWithSHA256(email);
    const hashedMobile = await hashWithSHA256(contactNumber);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "customerRequest_submit",
      inquiryType: inquiry,
      buttonName: "SUBMIT",
      email: hashedEmail, // Encrypted email of the User using SHA-256 encryption
      contactNumber: hashedMobile, // Encrypted contact Number of the User using SHA-256 encryption
      clientID: clientValue,
      queryMessage: msgValue,
      state: "",
      pageSection: "GET IN TOUCH WITH US",
      Category: "",
      FAQ: "",
    });

    if (fullname === "") {
      setErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (email === "") {
      setErrorMsg(true);
    } else if (!isEmailValid(email)) {
      setEmailErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (contactNumber === "") {
      setErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (inquiry === "") {
      setErrorMsg(true);
    } else {
      setErrorMsg(false);
    }

    if (!fullname || !email || !contactNumber) {
      return;
    } else {
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);

      let payload = {
        inquiryType: inquiry,
        fullName: fullname,
        email: email,
        contactNo: contactNumber,
        panNo: panValue,
        clientId: clientValue,
        queryMsg: msgValue,
        // txnId: reqId.requestId,
      };

      let encrypted = encrypt(payload, secret);

      let response = await setContactDetails(JSON.stringify(encrypted), {
        mode: "cors",
      });
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("DEcrypted dta", decryptedData);

      if (decryptedData.status == "success") {
        // alert("Successfully sent");
        // window.location.reload();
        toast.success(TOAST_COMMON_SUCCESS);
        setInquiry("");
        setFullName("");
        setEmail("");
        setContactNumber("");
        setPanValue("");
        setClientValue("");
        setMsgValue("");
      } else {
        // alert("Something went wrong");
        toast.error(TOAST_COMMON_ERROR);
      }
    }
  }
  let data;
  let bannerImage;
  let formImage;
  let officeData;
  let branchData;

  useEffect(() => {
    async function callApis() {
      await getContactUsDetails();
    }
    callApis();
  }, []);

  async function getContactUsDetails() {
    try {
      setLoader(true);
      const home = await getContactDetails();

      const resopnse = home.data;
      const data = resopnse.form.details;
      const bannerImage = resopnse.banner[0];
      const formImage = resopnse.form.background[0];
      const officeData = resopnse.offices;
      const branchData = resopnse.branches.sort((a, b) => a.id - b.id);

      setResponseData(data);
      setBanner(bannerImage);
      setFormBackground(formImage);
      setOffices(officeData);
      setBranches(branchData);
      setLoader(false);
    } catch (error) {
      // Handle API call failure
      console.error("API call failed:", error);
      // Display static image when API call fails
      setApiError(true);
      setLoader(true);
    }
  }

  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [isFocusedEmail, setIsFocusedEmail] = useState(false);
  const [isBlurEmail, setIsBlurEmail] = useState(false);
  const [isFocusedContact, setIsFocusedContact] = useState(false);
  const [isBlurContact, setIsBlurContact] = useState(false);
  const [isFocusedPan, setIsFocusedPan] = useState(false);
  const [isBlurPan, setIsBlurPan] = useState(false);
  const [isFocusedClient, setIsFocusedClient] = useState(false);
  const [isBlurClient, setIsBlurClient] = useState(false);
  const [isFocusedmsg, setIsFocusedmsg] = useState(false);
  const [isBlurmsg, setIsBlurmsg] = useState(false);
  const [isFocusedinquiry, setIsFocusedinquiry] = useState(false);
  const [isBlurinquiry, setIsBlurinquiry] = useState(false);
  const isMobile = useMediaQuery("(min-width: 300px)and (max-width:600px");
  const isTablet = useMediaQuery("(min-width: 601px) and (max-width: 900px)");
  const isDesktop = useMediaQuery("(min-width: 901px) and (max-width:1399px");
  const isLarge = useMediaQuery("(min-width:1400px ) and (max-width:2000px)");

  const textFieldStyle = {
    width: isMobile
      ? "200px"
      : isTablet
      ? "180px"
      : isDesktop
      ? "180px"
      : isLarge
      ? "300px"
      : "400px",
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Corporation",
    name: "ICICI Prudential Alternate Investments",
    url: "https://www.iciciprualternates.com/",
    logo: "https://www.iciciprualternates.com/static/media/logo.7de77484.svg",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "1800-268-0001",
      contactType: "customer service",
      areaServed: "IN",
      availableLanguage: "en",
    },
    sameAs: [
      "https://www.facebook.com/people/ICICI-Prudential-Alternate-Investments/61564527142001/",
      "https://x.com/ICICIAlternates",
      "https://www.instagram.com/iprualtinvestments/",
      "https://www.youtube.com/channel/UCx8zm0so0yzcIC3w2IdEndw",
      "https://www.linkedin.com/company/icici-prudential-amc-ltd",
    ],
  };

  return (
    <div className={styles.contactUs}>
      {loader === true ? (
        <Loader />
      ) : (
        <>
          <SeoHelmet
            title="Investment Opportunities - ICICI Pru Alternates Wealth Management"
            description="Explore investment opportunities with ICICI Pru Alternates. Our expert strategies are designed to secure your financial future. Start investing with us today."
            url="https://www.iciciprualternates.com/existing-investor"
            schemaJson={productSchema}
          />
          <Mail />
          {formbackground["image"] ? (
            <>
              <div className={styles.contactUsContainer}>
                <div className={styles.contactBanner}>
                  {formbackground["image"] && (
                    // <img
                    //   src={IMAGE_URL + formbackground["image"] + SITE_ID}
                    //   alt="form-banner"
                    // />
                    <img
                      src={ContactusBanner}
                      alt="form-banner"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(
                          "https://www.iciciprualternates.com/portal"
                        );
                      }}
                    />
                  )}

                  <div className={styles.divContactText}>
                    {/* <h1 style={{ color: "#97291e" }}>{banner.title} </h1>
                    <p className={styles.callusOn}>
                      {responseData.length > 0 ? responseData[0].title : ""}
                    </p>
                    <p className={styles.contactNumber}>
                      {responseData.length > 0
                        ? ReactHtmlParser(responseData[0].description)
                        : ""}
                    </p>
                    <div className={styles.contactHours}>
                      <p className={styles.businessHours}>
                        {responseData.length > 1 ? responseData[1].title : ""}
                      </p>
                      <p className={styles.sunday}>
                        <span className={styles.weekend}>
                          {responseData.length > 1
                            ? ReactHtmlParser(responseData[1].description)
                            : ""}
                        </span>
                      </p>
                    </div> */}
                  </div>
                  <div className={styles.subDiv}>
                    {/* <a href="https://apps.iciciprupms.com/wealthspectrum/app/login" target="_blank" style={{fontSize: "12px", fontWeight: '500', color: 'white'}}>Investor Login </a>
                  <a href="https://apps.iciciprupms.com/VCF_AIF_WEB?Flag=E" target="_blank" style={{fontSize: "12px", fontWeight: '500', color: 'white'}}>Fund Login (AIF) </a> */}
                    <button
                      onClick={() => {
                        window.open(
                          "https://www.iciciprualternates.com/portal"
                        );
                      }}
                    >
                      Click to Explore
                    </button>
                    {/* <button
                      onClick={() => {
                        window.open("https://apps.iciciprupms.com/VCF_AIF_WEB?Flag=E")
                      }}
                    >
                      Fund Login (AIF)
                    </button> */}
                  </div>
                </div>
                <div className={styles.formContainer}>
                  <h5 className={styles.contactUsHeading}>
                    GET IN TOUCH WITH US
                  </h5>

                  <FormControl
                    variant="standard"
                    sx={{ m: 1, minWidth: 120 }}
                    className={styles.contactForm}
                  >
                    <div className={styles.inputwrapper}>
                      <div
                        onMouseOver={handleImageChangeQury}
                        onMouseLeave={handleChangeImageQuery}
                      >
                        {selectQuery ? (
                          <img src={query} alt="Query" />
                        ) : (
                          <img src={originalQuery} alt="Query" />
                        )}
                      </div>
                      <div className={styles.selectQuryContainer}>
                        {isFocusedinquiry ? (
                          <></>
                        ) : (
                          <InputLabel
                            className={`querySelector ${styles.selectQueryLabel}`}
                            id="demo-simple-select-label"
                          >
                            Select Inquiry
                            <span className="asterick">*</span>
                          </InputLabel>
                        )}
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={inquiry}
                          onChange={handleChange}
                          label={isFocusedinquiry ? "" : "Select Inquiry"}
                          disableUnderline
                          className={{ focused: styles.selected }}
                          MenuProps={{ animated: false }}
                          // className={styles.querySelecorclass}
                          required
                          style={{ textAlign: "start" }}
                          InputLabelProps={{
                            style: { fontSize: 16 },
                          }}
                          onFocus={() => setIsFocusedinquiry(true)}
                          onBlur={() => setIsFocusedinquiry(true)}
                        >
                          <MenuItem disabled value="">
                            Select Inquiry
                          </MenuItem>
                          {inquiries.map((item) => {
                            return (
                              <MenuItem
                                value={item.name}
                                key={item.id + item.name}
                              >
                                {item.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                    </div>
                    {errorMsg ? (
                      <span className={styles.errorMsgContact}>
                        Please select a query
                      </span>
                    ) : (
                      ""
                    )}
                    <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                      <div
                        onMouseOver={handleImageChangeFormName}
                        onMouseLeave={handleChangeImageFormName}
                      >
                        {changeImage ? (
                          <img src={formNameChange} alt="form-name-golden" />
                        ) : (
                          <img src={formName} alt="form-name" />
                        )}
                      </div>
                      <div
                        className={`textFieldContainer ${
                          isFocused
                            ? styles.contactfullnameFieldFocus
                            : styles.contactfullnameField
                        }`}
                      >
                        <TextField
                          id="full-name"
                          label={isFocused ? "" : "Full Name"}
                          type="name"
                          inputProps={{ maxLength: 64 }}
                          autoComplete=""
                          InputProps={{ disableUnderline: true }}
                          className={styles.contactTextfield}
                          placeholder="Arjun Kumar"
                          onChange={(e) => handleChangeName(e)}
                          value={fullname}
                          required
                          onFocus={() => setIsFocused(true)}
                          onBlur={() => setIsBlur(true)}
                          style={textFieldStyle}
                        />
                      </div>
                    </div>
                    {nameErrorMsg && errorMsg ? (
                      <span className={styles.errorMsgContact}>
                        Enter valid Name
                      </span>
                    ) : nameErrorMsg ? (
                      <span className={styles.errorMsgContact}>
                        Enter valid Name
                      </span>
                    ) : errorMsg ? (
                      <span className={styles.errorMsgContact}>Required</span>
                    ) : (
                      ""
                    )}
                    <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                      <div
                        onMouseOver={handleImageChangeFormMail}
                        onMouseLeave={handleChangeImageFormMail}
                      >
                        {changeMail ? (
                          <img src={formMailChange} alt="form-mail-golden" />
                        ) : (
                          <img src={formMail} alt="form-mail" />
                        )}
                      </div>
                      <div
                        className={`textFieldContainer ${
                          isFocusedEmail
                            ? styles.contactemailFieldFocus
                            : styles.contactemailField
                        }`}
                      >
                        <TextField
                          id="email"
                          label={isFocusedEmail ? "" : "Email"}
                          type="email"
                          autoComplete="off"
                          InputProps={{ disableUnderline: true }}
                          className={styles.contactTextfield}
                          placeholder={EMAIL_PLACEHOLDER}
                          required
                          value={email}
                          inputProps={{ maxLength: 70 }}
                          onChange={(e) => handleEmailChange(e)}
                          onFocus={() => setIsFocusedEmail(true)}
                          onBlur={() => setIsBlurEmail(true)}
                          style={textFieldStyle}
                        />
                      </div>
                    </div>
                    {emailErrorMsg ? (
                      <span className={styles.errorMsgContact}>
                        {ENTER_VALID_EMAIL}
                      </span>
                    ) : (
                      ""
                    )}
                    {errorMsg ? (
                      <span className={styles.errorMsgContact}>Required</span>
                    ) : (
                      ""
                    )}
                    <div className={`mailInputWrapper ${styles.inputwrapper}`}>
                      <div
                        onMouseOver={handleImageChangeFormContact}
                        onMouseLeave={handleChangeImageFormContact}
                      >
                        {changeContact ? (
                          <img
                            src={formContactChange}
                            alt="form-contact-golden"
                          />
                        ) : (
                          <img src={formContact} alt="form-contact" />
                        )}
                      </div>
                      <div className="contactInput">
                        {isFocusedContact ? (
                          <></>
                        ) : (
                          <label className={`${isFocusedContact ? "" : ""} `}>
                            Contact Number<span className="asterick">*</span>
                          </label>
                        )}
                        <div className="contactNumbercode">
                          {countryCode ? (
                            <span
                              className="countryCode"
                              style={{ fontSize: "16px" }}
                            >
                              +91-
                            </span>
                          ) : (
                            ""
                          )}{" "}
                          <input
                            type="text"
                            className="contactNumber"
                            onChange={(e) => handleTextChange(e.target.value)}
                            onClick={() => setCountryCode(true)}
                            onBlur={() => {
                              if (!contactNumber) {
                                setCountryCode(false);
                              }
                              setIsBlurContact(true);
                            }}
                            onFocus={() => setIsFocusedContact(true)}
                            value={contactNumber}
                            maxLength={10}
                            // placeholder="9880546703"
                          />
                        </div>
                      </div>
                    </div>
                    {numberErrorMsg ? (
                      <span className={styles.errorMsgContact}>
                        {ENTER_VALID_CONTACT_NUMBER}
                      </span>
                    ) : (
                      ""
                    )}
                    {errorMsg ? (
                      <span className={styles.errorMsgContact}>Required</span>
                    ) : (
                      ""
                    )}
                    <div className={styles.panClientContainer}>
                      <div className={styles.panContainer}>
                        <div
                          className={`mailInputWrapper ${styles.inputwrapper}`}
                        >
                          <div
                            onMouseOver={handleImageChangepan}
                            onMouseLeave={handleChangeImagepan}
                          >
                            {panImg ? (
                              <img src={panGolden} alt="pan-golden" />
                            ) : (
                              <img src={pan} alt="pan" />
                            )}
                          </div>
                          <div
                            className={`textFieldContainer ${
                              isFocusedPan
                                ? styles.contactpanFieldFocus
                                : styles.contactpanField
                            }`}
                          >
                            <TextField
                              id="pan-number"
                              label={isFocusedPan ? "" : "PAN"}
                              type="text"
                              autoComplete=""
                              InputProps={{ disableUnderline: true }}
                              className={styles.contactTextfield}
                              placeholder="PAN"
                              onChange={(e) => handleChangePan(e)}
                              value={panValue}
                              inputProps={{ maxLength: 10 }}
                              onInput={(e) => {
                                //e.target.value = (e.target.value).toString().slice(0, 10)
                              }}
                              onFocus={() => setIsFocusedPan(true)}
                              onBlur={() => setIsBlurPan(true)}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <span className={styles.orText}>OR</span> */}
                      <div className={styles.clientIdContainer}>
                        <div
                          className={`mailInputWrapper ${styles.inputwrapper}`}
                        >
                          <div
                            onMouseOver={handleImageChangeClientId}
                            onMouseLeave={handleChangeImageClienId}
                          >
                            {clientImg ? (
                              <img src={clientGolden} alt="clientId-golden" />
                            ) : (
                              <img src={client} alt="clientId" />
                            )}
                          </div>
                          <div
                            className={`textFieldContainer ${
                              isFocusedClient
                                ? styles.contactclientFieldFocus
                                : styles.contactclientField
                            }`}
                          >
                            <TextField
                              id="client-id"
                              label={isFocusedClient ? "" : "Client Id"}
                              type="text"
                              autoComplete=""
                              InputProps={{ disableUnderline: true }}
                              className={styles.contactTextfield}
                              placeholder="Client Id"
                              onChange={(e) => handleChangeClientId(e)}
                              // onInput={(e) => {
                              //     e.target.value = (e.target.value).toString().slice(0, 10)
                              // }}
                              value={clientValue}
                              onFocus={() => setIsFocusedClient(true)}
                              onBlur={() => setIsBlurClient(true)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {panError ? (
                      <span className={styles.errorMsgContact}>
                        Enter valid PAN number
                      </span>
                    ) : (
                      ""
                    )}
                    {clientError ? (
                      <span className={styles.errorMsgContact}>
                        Enter valid Client ID
                      </span>
                    ) : (
                      ""
                    )}

                    <div className={styles.queryContainer}>
                      <div
                        className={`mailInputWrapper ${styles.inputwrapper}`}
                      >
                        <div
                          onMouseOver={handleImageChangeMsg}
                          onMouseLeave={handleChangeImageMsg}
                        >
                          {msgImg ? (
                            <img src={msgGolden} alt="msg-golden" />
                          ) : (
                            <img src={msg} alt="msg" />
                          )}
                        </div>
                        <div
                          className={`textFieldContainer ${
                            isFocusedmsg
                              ? styles.contactmsgFieldFocus
                              : styles.contactmsgField
                          }`}
                        >
                          <TextField
                            inputProps={{ maxLength: 500 }}
                            id="query-msg"
                            label={isFocusedmsg ? "" : "Query Message"}
                            type="text"
                            autoComplete=""
                            InputProps={{ disableUnderline: true }}
                            className={styles.contactTextfield}
                            placeholder="Enter your query"
                            onChange={(e) => handleChangeMsg(e)}
                            value={msgValue}
                            onFocus={() => setIsFocusedmsg(true)}
                            onBlur={() => setIsBlurinquiry(true)}
                            style={textFieldStyle}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`formSubmit ${styles.contactSubmit}`}
                      onClick={handleSubmit}
                    >
                      SUBMIT
                    </div>
                  </FormControl>
                </div>
              </div>
            </>
          ) : null}

          <div className={styles.officeContainer}>
            <h1 className={styles.ourOfficesHeading}>Our Offices </h1>
            <div className={styles.locationContainer}>
              <div className={styles.firstLocation}>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {offices.length > 2 ? offices[2].title : ""}
                    </h2>
                    <img src={location} alt="location" />
                  </div>
                  <div className={styles.locationAddress}>
                    {offices.length > 2
                      ? ReactHtmlParser(offices[2].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstLocation}>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {offices.length > 0 ? offices[0].title : ""}
                    </h2>
                    <img src={location} alt="location" />
                  </div>
                  <div className={styles.locationAddress}>
                    {offices.length > 0
                      ? ReactHtmlParser(offices[0].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstLocation}>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {offices.length > 1 ? offices[1].title : ""}
                    </h2>
                    <img src={location} alt="location" />
                  </div>
                  <div className={styles.locationAddress}>
                    {offices.length > 1
                      ? ReactHtmlParser(offices[1].description)
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.branchContainer}>
            <h1 className={styles.ourBranchHeading}>Our Other Branches </h1>
            <div className={styles.otherBranchContainer}>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[0] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 1
                          ? IMAGE_URL + branches[0].image + SITE_ID
                          : ""
                      }
                      alt="branch1"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 1 ? branches[0].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 1
                      ? ReactHtmlParser(branches[0].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[1] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 0
                          ? IMAGE_URL + branches[1].image + SITE_ID
                          : ""
                      }
                      alt="branch2"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 0 ? branches[1].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 0
                      ? ReactHtmlParser(branches[1].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[2] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 3
                          ? IMAGE_URL + branches[2].image + SITE_ID
                          : ""
                      }
                      alt="branch3"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 2 ? branches[2].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                      loading="lazy"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 2
                      ? ReactHtmlParser(branches[2].description)
                      : ""}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.otherBranchContainerSecondRow}>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[3] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 5
                          ? IMAGE_URL + branches[3].image + SITE_ID
                          : ""
                      }
                      alt="branch4"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 5 ? branches[3].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 5
                      ? ReactHtmlParser(branches[3].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[4] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 3
                          ? IMAGE_URL + branches[4].image + SITE_ID
                          : ""
                      }
                      alt="branch5"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 3 ? branches[4].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 3
                      ? ReactHtmlParser(branches[4].description)
                      : ""}
                  </div>
                </div>
              </div>
              <div className={styles.firstBranch}>
                <div className={styles.branchImg}>
                  {branches[5] && (
                    <img
                      className={styles.place}
                      src={
                        branches.length > 4
                          ? IMAGE_URL + branches[5].image + SITE_ID
                          : ""
                      }
                      alt="branch6"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className={styles.locationContent}>
                  <div className={styles.locationHeading}>
                    <h2 className={styles.locHaed}>
                      {branches.length > 4 ? branches[5].title : ""}
                    </h2>
                    <img
                      src={location}
                      className={styles.location}
                      alt="location"
                    />
                  </div>
                  <div className={styles.locationAddress}>
                    {branches.length > 4
                      ? ReactHtmlParser(branches[5].description)
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ContactUs;
